import capitalize from 'lodash/capitalize'

export default function getActivityTitle ({ displayName = '', type = '' }) {
  return displayName || capitalize(type)
}
